import { takeLatest } from 'redux-saga/effects';
import userSagas from './userSagas';
import trainingSagas from './trainingSagas';
import ActionTypes from '../actions/types';

function* watchUserRequests() {
  yield takeLatest(ActionTypes.REGISTER_REQUEST, userSagas.registerSaga);
  yield takeLatest(ActionTypes.LOGIN_REQUEST, userSagas.loginSaga);
  yield takeLatest(ActionTypes.LOGOUT_REQUEST, userSagas.logoutSaga);
  yield takeLatest(ActionTypes.USER_UPDATE_REQUEST, userSagas.updateUserSaga);
  yield takeLatest(ActionTypes.USER_UPDATE_IMG_REQUEST, userSagas.updateUserImgSaga);
}

function* watchTrainingRequests() {
  yield takeLatest(ActionTypes.GET_WORKOUTS_REQUEST, trainingSagas.getWorkoutsSaga);
  yield takeLatest(ActionTypes.GET_WORKOUT_REQUEST, trainingSagas.getWorkoutSaga);
  yield takeLatest(ActionTypes.GET_EXERCISES_REQUEST, trainingSagas.getExercisesSaga);
}

const watchers = {
  watchTrainingRequests,
  watchUserRequests,
};

export default watchers;
